import React from 'react';
import I18n from 'i18n-js';
import { clsx } from 'clsx';
import AssignmentCard from './AssignmentCard';
import { UserType } from '../../types';
import styles from './AssignmentCards.module.scss';

interface AssignmentCardsProps {
  assignments: any[];
  subsection: 'upcoming' | 'overdue';
  user: UserType;
  useSubsections: boolean;
}

const AssignmentCards = ({ assignments, subsection, user, useSubsections }: AssignmentCardsProps) => {
  const isStudent = user.type === 'Student';

  const renderNoAssignmentsMessage = () => (
    <div className="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center">
      {isStudent && subsection === 'upcoming' && (
        <i className="fa fa-icon fa-check-circle tw-text-green tw-text-4xl tw-mb-1" />
      )}
      <div className="tw-text-[18px]">
        {!isStudent ? (
          I18n.t('you_have_no_current_assignments')
        ) : (
          subsection === 'upcoming' && I18n.t('you_have_no_upcoming_assignments')
        )}
      </div>
    </div>
  );

  const getAssignmentCards = () => (
    assignments
      .sort((a, b) => {
        const dueDateA = new Date(a.due_datetime);
        const dueDateB = new Date(b.due_datetime);
        return dueDateA.getTime() - dueDateB.getTime();
      })
      .map(assignment => (
        <AssignmentCard
          key={`assignment-card-${assignment.id}`}
          assignment={assignment}
          assignmentModelsHash={assignment.assignment_models_hash}
          isOverdue={subsection === 'overdue'}
          user={user}
        />
      ))
  );

  const getSubsection = () => {
    if (subsection === 'overdue' && assignments.length === 0) return <></>;

    const label = (subsection === 'overdue') ? I18n.t('overdue') : I18n.t('upcoming');
    const subsectionText = `${label} (${assignments.length})`;

    return (
      <>
        {useSubsections && (
          <div className={styles.cardHeader}>
            <i className={clsx('tw-text-gray-500', {
              'fa fa-clock-o': subsection === 'upcoming',
              'fa fa-times-circle': subsection === 'overdue',
            })}
            />
            <span className="tw-pl-2 tw-text-gray-600">{subsectionText}</span>
          </div>
        )}
        {assignments.length > 0 ? getAssignmentCards() : renderNoAssignmentsMessage()}
      </>
    );
  };

  return (
    <div className={styles.subsection}>
      {getSubsection()}
    </div>
  );
};

export default AssignmentCards;
